export default [{"url":"https://grace-0.api.invexerp.io","name":"Branch 1","port":"5044","isStore":true,"isHQ":true}]